export const labels = {
	title: {
		label: "Label.MobileCreator.RestartProduct.Title",
		default: "Restart Product",
	},
	message: {
		label: "Label.MobileCreator.RestartProduct.Message",
		default: "Are you sure you want to restart your product?",
	},
	restart: {
		label: "Label.MobileCreator.RestartProduct.RestartProduct",
		default: "Restart",
	},
	goBack: {
		label: "Label.MobileCreator.RestartProduct.GoBack",
		default: "Back to product",
	},
};
